import React from 'react';

// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import {
  AccordionButton,
  forwardRef,
  useAccordionItemState,
  useTheme,
} from '@chakra-ui/react';

import { Box } from '../../../component-primitives';
import { useDescendantsVariantContext } from '../../../hooks/use-descendants-variant-context';
import {
  ArrowLittleDownIcon,
  ArrowLittleRightIcon,
  MinusIcon,
  PlusIcon,
} from '../../icons';
import { AccordionHeaderProps } from './types';

const isCompactFromVariant = (variant: string) =>
  ['group-compact'].includes(variant);

const AccordionHeader = forwardRef<AccordionHeaderProps, 'button'>(
  ({ children, ...rest }, ref) => {
    const theme = useTheme();
    const { isOpen } = useAccordionItemState();
    const { variant: variantFromParent } = useDescendantsVariantContext();

    const variant =
      variantFromParent || theme.components?.Accordion?.defaultProps.variant;

    const isCompact = isCompactFromVariant(variant?.toString() || '');

    return (
      <AccordionButton ref={ref} {...rest}>
        {isCompact &&
          (isOpen ? <ArrowLittleDownIcon /> : <ArrowLittleRightIcon />)}
        <Box as="span" flex="1" textAlign="left" pr="5">
          {children}
        </Box>
        {!isCompact && (isOpen ? <MinusIcon /> : <PlusIcon />)}
      </AccordionButton>
    );
  }
);

export { AccordionHeader };
